
import { defineComponent, ref, watch, onMounted } from 'vue'
import store from '@/store'
import { RouterLink, useRoute, useRouter } from 'vue-router'
import { useWindowSize } from '@vueuse/core'

export default defineComponent({
  setup() {
    const { width } = useWindowSize()
    const isMobile = ref(false)

    watch(width, (val) => {
      if (val < 650) {
        isMobile.value = true
      } else {
        isMobile.value = false
      }
    })

    onMounted(() => {
      isMobile.value = window.innerWidth < 650
    })
    return {
      defineComponent,
      store,
      RouterLink,
      useRoute,
      useRouter,
      isMobile,
    }
  },
  data() {
    return {
      isActiveBack: true,
    }
  },
  computed: {
    currentUser() {
      return store.getters.getUserCurrent
    },
  },
  watch: {
    $route(to) {
      this.isActiveBack = to.path !== '/'
    },
  },
  methods: {
    routeBack() {
      // location.href = !window.history.state.back
      //   ? '/'
      //   : window.history.state.back
      this.$router.back()
    },
  },
})
